import { createElement } from 'react'
import icons from '../assets/icons'
import { styled, Style } from 'inlines'
import { ThemeColors } from '../providers/useTheme'

export const ICONS = Object.keys(icons)

export type IconProps = {
  variant: keyof typeof icons
  size?: 'regular' | 'small'
  style?: Style
  color?: string | ThemeColors
  'aria-hidden'?: boolean
}

export function Icon({
  variant,
  size = 'regular',
  style = {},
  color = 'black',
  'aria-hidden': ariaHidden,
}: IconProps) {
  const El = icons[variant]

  style.flexShrink ??= 0

  return El ? (
    <styled.svg
      viewBox={'0 0 24 24'}
      fill="currentColor"
      aria-hidden={ariaHidden}
      style={{
        color: color as string,
        width: size === 'small' ? 16 : 24,
        height: size === 'small' ? 16 : 24,
        ...style,
      }}
    >
      {createElement(El)}
    </styled.svg>
  ) : null
}
